module.exports = __webpack_public_path__ + "static/content-dc720e045d27bb097be4f05e40ebae5d.svg";